import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ "table", "moreButton", "lessButton" ]

  more(e) {
    e.preventDefault()
    this.tableTarget.classList.replace('less', 'more')
    this.moreButtonTarget.classList.add('d-none')
    this.lessButtonTarget.classList.remove('d-none')
  }

  less(e) {
    e.preventDefault()
    this.tableTarget.classList.replace('more', 'less')
    this.moreButtonTarget.classList.remove('d-none')
    this.lessButtonTarget.classList.add('d-none')
  }
}
